import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberSuffix',
})
export class NumberSuffixPipe implements PipeTransform {
  transform(input: any, args?: any): any {
    // let exp;
    // const suffixes = ['M', 'B', 'T', 'P', 'E'];
    // const isNagtiveValues = input < 0;

    // if (Number.isNaN(input) || !this.isNumeric(input)) {
    //   return input;
    // }

    // if (Math.abs(input) < 1000000 && Math.abs(input) >= 0) {
    //   return (input / 1000000).toFixed(args) + 'M';
    // } else {
    //   if (!isNagtiveValues) {
    //     exp = Math.floor(Math.log(input) / Math.log(1000000));

    //     return (
    //       (input / Math.pow(1000000, exp)).toFixed(args) + suffixes[exp - 1]
    //     );
    //   } else {
    //     input = input * -1;

    //     exp = Math.floor(Math.log(input) / Math.log(1000000));
    //     return (
    //       ((input * -1) / Math.pow(1000000, exp)).toFixed(args) +
    //       suffixes[exp - 1]
    //     );
    //   }
    // }
    
    const isNegative = input < 0;
    const absInput = Math.abs(input);

    if (Number.isNaN(input) || !this.isNumeric(input)) {
      return input;
    }

    // Handle zero
    if (absInput === 0) {
      return '0';
    }

    // For values less than 1 million (thousands)
    if (absInput < 1000000) {
      const millions = (input / 1000000).toFixed(args || 1);
      return millions + 'M';
    }
    
    // For values between 1 million and 1 billion (millions)
    if (absInput >= 1000000 && absInput < 1000000000) {
      const millions = (input / 1000000).toFixed(args || 1);
      return millions + 'M';
    }
    
    // For values 1 billion and above (billions)
    if (absInput >= 1000000000) {
      const billions = (input / 1000000000).toFixed(args || 1);
      return billions + 'B';
    }

    return input;
  }

  isNumeric(value): boolean {
    if (value < 0) value = value * -1;
    if (/^-{0,1}\d+$/.test(value)) {
      return true;
    } else if (/^\d+\.\d+$/.test(value)) {
      return true;
    } else {
      return false;
    }
  }
}
